import React, { useEffect, useState } from 'react';
import { Accordion, Form } from 'react-bootstrap';
import { formatMessage } from '../../../translations/format-message';

interface CheckItemsDataProps {
  checkItems: any[];
  isTimerRunning: boolean;
  activeIndex: number;
  setSubmittedCheckItems: React.Dispatch<React.SetStateAction<any>>;
  submittedCheckItems: any;
}

const CheckItemsData: React.FC<CheckItemsDataProps> = ({
  checkItems,
  isTimerRunning,
  activeIndex,
  setSubmittedCheckItems,
  submittedCheckItems,
}) => {
//   const [items, setItems] = useState<any[]>([]);

//   // ✅ sync with props and initialize local printed state
//   useEffect(() => {
//     setItems(checkItems || []);
//   }, [checkItems]);

  const handleInfoChange = (
    stepIndex: number,
    itemId: number,
    value: string
  ) => {
    setSubmittedCheckItems((prev) => ({
      ...prev,
      [stepIndex]: {
        ...(prev[stepIndex] || {}),
        [itemId]: {
          ...(prev[stepIndex]?.[itemId] || {}),
          InputMessage: value,
        },
      },
    }));
  };

  const handleCheckboxChange = (
    tabIndex: number,
    itemId: number | undefined,
    checked: boolean
  ) => {
    if (itemId === undefined || itemId === null) {
      // console.warn('Checkbox itemId missing!', { tabIndex, checked });
      return;
    }

    setSubmittedCheckItems((prev) => {
      const updated = {
        ...prev,
        [tabIndex]: {
          ...(prev[tabIndex] || {}),
          [itemId]: {
            ...(prev[tabIndex]?.[itemId] || {}),
            isChecked: checked,
            InputMessage: prev[tabIndex]?.[itemId]?.InputMessage || '',
          },
        },
      };
      return updated;
    });
  };

  return (
    <div className="operator_check_items">
      {(!checkItems || checkItems.length === 0) && (
        <div className="h-100 d-flex justify-content-center align-items-center text-muted p-2">
          {formatMessage('no_check_items_available')}
        </div>
      )}
      {checkItems && checkItems.length > 0 && (
          <Accordion className="w-100 operator-child-accordion">
            {checkItems.map((item: any, index) => (
              <Accordion.Item
                // eventKey={item[index]?.Order || '0'}
                eventKey={`${activeIndex}-${item.id ?? index}`}
                className="my-2 operator-child-accordion-item"
              >
                <Accordion.Header>
                  <span className="operator-checkitems-list-title p-1">
                    {item?.Title}
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  {item.CheckItemMessage?.map(
                    (msgItem: any, msgIndex: number) => (
                      <div key={msgIndex} className="mb-1">
                        <div className="row g-1 row-operator-check-item">
                          <div className="col-auto">
                            <div className="d-flex">
                              <Form.Check
                                type="checkbox"
                                id={`check-${activeIndex}-${msgItem.Id}`}
                                checked={
                                  submittedCheckItems[activeIndex]?.[msgItem.Id]
                                    ?.isChecked ??
                                  msgItem.IsChecked ??
                                  false
                                }
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    activeIndex,
                                    msgItem.Id,
                                    e.target.checked
                                  )
                                }
                                disabled={!isTimerRunning}
                                className="m-0"
                              />
                              <span className="ps-2 operator-checkitems-list-message">
                                {msgItem.CheckMessage || ''}
                              </span>
                            </div>
                          </div>
                          <div className="col">
                            {msgItem.IsInfo && (
                              <input
                                type="text"
                                className="form-control"
                                id={`info-${activeIndex}-${msgItem.Id}`}
                                name="InputMessage"
                                value={
                                  submittedCheckItems[activeIndex]?.[msgItem.Id]
                                    ?.InputMessage || ''
                                }
                                onChange={(e) =>
                                  handleInfoChange(
                                    activeIndex,
                                    msgItem.Id,
                                    e.target.value
                                  )
                                }
                                disabled={!isTimerRunning}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
      )}
    </div>
  );
};

export default CheckItemsData;
